import { BathTypeContainer } from '../../containers/advancedFilters/BathTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const bathType: IFilter = {
  component: BathTypeContainer,
};
